import { fetchApi } from '@/requests/api';
import { BASE_DASHBOARD_URL } from '@/requests/constants';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type { DashBoard } from '../types';
import { useSession } from '@/providers/session-provider';

export const DASHBOARD_QUERY_KEY = 'dashboard';

export function useGetDashboards(
  options?: Omit<UseQueryOptions<DashBoard[]>, 'queryKey'>
) {
  const {
    data: { session },
  } = useSession();
  return useQuery({
    ...options,
    queryKey: [DASHBOARD_QUERY_KEY],
    queryFn: async () => {
      const res = await fetchApi({
        url: `${BASE_DASHBOARD_URL}/myworkday/dashboard/user`,
      });

      const data = await res.json();
      return Array.isArray(data) ? data : [];
    },
    enabled: !!session.token,
    staleTime: 60 * 5 * 1000,
    refetchOnWindowFocus: true,
  });
}
